export default "__VITE_ASSET__BattI7K___"